module.exports = __webpack_public_path__ + "static/media/connection-1.07700124.svg";